import React, { useContext, useEffect } from 'react';

import { Props } from './Navigation.types';
import { Styled } from './Navigation.styles';

import { mainCordovaContext } from '../context';
import { useDispatch, useSelector }    from 'react-redux';
import { actions, IUser, Permissions } from 'reducer/user';
import { useLocation }                 from 'react-router';
import { IRootState } from '../../../../reducer';
import { Page } from '../components/Page';

import * as permissions from 'shared/consts/permissions';

import { LogoutButton } from '../components/NavigationButton';

const routes = [
  {
    url: '/map',
    name: 'Карта',
    access: permissions.MAP,
  },
  {
    url: '/video',
    name: 'Видео',
    access: permissions.VIDEO_VIEW_ACCESS,
  },
  {
    url: '/bc',
    name: 'Проведение билетного контроля',
    access: permissions.BC_ACCESS,
  },
  {
    url: '/handbooks',
    name: 'Справочники',
    access: permissions.CATALOG_ACCESS,
  },
  { url: '/about', name: 'О платформе' },
];

export const Navigation: React.FC<Props> = () => {
  const { toggleNavigation } = useContext(mainCordovaContext);

  const userPermissions = useSelector<IRootState, Permissions | null>(
    ({ user }) => user?.permissions || null
  );

  const location = useLocation();
  // useEffect(() => {
  //   if (showNavigation) {
  //     push('?open=true');
  //   }
  // }, [push, showNavigation]);

  const dispatch = useDispatch();

  const showNavigation =
    new URLSearchParams(location.search).get('navState') === 'open';

  const build = useSelector<IRootState, string>(({ user }) => user.build);

  if (!showNavigation) return null;

  return (
    <Styled.NavigationWrapper>
      <Page
        primaryButtonNode={null}
        title="Меню УМП"
        actionButton={<LogoutButton />}
      >
        <Styled.Navigation>
          {routes
            .filter(({ access }) =>
              access === undefined ?? true
            )
            .map(({ name, url }) => (
              <Styled.NavButton
                key={url}
                to={url}
                onClick={() => toggleNavigation(false)}
              >
                {name}
              </Styled.NavButton>
            ))}
          <span>Версия системы: {build}</span>
        </Styled.Navigation>
      </Page>
    </Styled.NavigationWrapper>
  );
};
